import React from 'react';
import PropTypes from 'prop-types';
import EditorField from '../Editor/editor-field';

// It should render a dropdown, with the possibility of freeText
// onChange should set the property value of the conditions array specified by the rowIndex

function PolicyConditionProperty(props) {
  const {
    rowItem,
    rowIndex,
    isEditing,
    customAttributes,
    temporaryPolicy,
    validateObject,
  } = props;

  const isErrored = rowItem.errorArray && rowItem.errorArray.includes('property');

  const selectItem = (item) => {
    const newObject = { ...temporaryPolicy };
    newObject.conditions[rowIndex].property = item;
    validateObject(newObject);
  };

  return (
    <EditorField
      isEditing={isEditing}
      value={rowItem.property}
      selectItem={selectItem}
      items={customAttributes}
      isErrored={isErrored}
      placeholder="Choose an attribute"
    />
  );
}

PolicyConditionProperty.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  customAttributes: PropTypes.array.isRequired,
  temporaryPolicy: PropTypes.object.isRequired,
  rowItem: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  validateObject: PropTypes.func.isRequired,
};

export default PolicyConditionProperty;
